import React from 'react';
import { useCtx } from '../../../config/hooks';
import { IonContent } from '@ionic/react';
const ContactUsView: React.FC = () => {
	const ctx = useCtx<{}>({});
	const currentEvent = ctx.virtual.event.active();
	return (
		<IonContent>
			<iframe
				frameBorder="none"
				height="100%"
				width="100%"
				src={
					(currentEvent?.properties as any)?.app?.virtual?.topMenu
						?.contactUsPage?.en?.url ?? 'https://www.conexsys.com/contactUsPage'
				}
			></iframe>
		</IonContent>
	);
};

export default ContactUsView;
